import React, { useEffect, useState } from "react";
import {
  CombineInputGroup,
  InputGroup,
  Label,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";

export default function OccupationDetails({
  tenantData,
  setSelectedData,
  addOccupationDetailMutate,
  isOccupationDetailLoading,
}) {
  const [data, setData] = useState(tenantData?.tenant);

  useEffect(() => {
    setData(tenantData?.tenant);
  }, [tenantData]);

  const occupationFormik = useFormik({
    initialValues: {
      occupationDetails: data?.occupationDetails || "",
      companyName: data?.companyName || "",
      hrContact: data?.hrContact || "",
      workAddress: data?.workAddress || "",
      monthlyIncome: data?.monthlyIncome || "",
      incomeSource: data?.incomeSource || "",
    },
    validationSchema: Yup.object({
      occupationDetails: Yup.string(),
      companyName: Yup.string(),
      workAddress: Yup.string(),
      monthlyIncome: Yup.number(),
      incomeSource: Yup.string(),
    }),
    onSubmit: (values) => {
      if(!values.occupationDetails){
        toast.error("Occupation is required");
        return;
      }
      if(!values.companyName){
        toast.error("Company Name is required");
        return;
      }
      if(!values.workAddress){
        toast.error("Work Address is required");
        return;
      }
      if(!values.monthlyIncome){
        toast.error("Monthly Income is required");
        return;
      }
      if(!values.incomeSource){
        toast.error("Income Source is required");
        return;
      }
      addOccupationDetailMutate(values);
    },
    enableReinitialize: true,
  });

  return (
    <>
      <div>
        <Title>Occupation Details</Title>
        <form
          onSubmit={occupationFormik.handleSubmit}
          className="grid grid-cols-1 gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="occupationDetails">Occupation</Label>
              <FieldWrapper>
                <Select
                  id="occupationDetails"
                  name="occupationDetails"
                  className="w-full pl-2"
                  value={occupationFormik.values.occupationDetails}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                >
                  <MenuItem value="Self Employed">Self Employed</MenuItem>
                  <MenuItem value="Salaried">Salaried</MenuItem>
                </Select>
                {occupationFormik.touched.occupationDetails &&
                  occupationFormik.errors.occupationDetails && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.occupationDetails}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="companyName">Company Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={occupationFormik.values.companyName}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.companyName &&
                  occupationFormik.errors.companyName && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.companyName}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="hrContact">
                Supervisor/HR Contact (optional)
              </Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="hrContact"
                  name="hrContact"
                  value={occupationFormik.values.hrContact}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="workAddress">Work Address</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="workAddress"
                  name="workAddress"
                  value={occupationFormik.values.workAddress}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.workAddress &&
                  occupationFormik.errors.workAddress && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.workAddress}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="monthIncome">Monthly Income (₹)</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="monthlyIncome"
                  name="monthlyIncome"
                  value={occupationFormik.values.monthlyIncome}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.monthlyIncome &&
                  occupationFormik.errors.monthlyIncome && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.monthlyIncome}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="incomeSource">Income Source</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="incomeSource"
                  name="incomeSource"
                  value={occupationFormik.values.incomeSource}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.incomeSource &&
                  occupationFormik.errors.incomeSource && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.incomeSource}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn type="submit" disabled={isOccupationDetailLoading}>
              {isOccupationDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </div>
    </>
  );
}

const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;

const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
const SubmitBtn = tw.button`
text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-full shadow-md`;
